import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { WhatWeDo } from '../components/WhatWeDo';
import { Verticals } from '../components/Verticals';
import { WhyPartner } from '../components/WhyPartner';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-white" data-id="element-87">
      <Header data-id="element-88" />
      <main data-id="element-89">
        <Hero data-id="element-90" />
        <WhatWeDo data-id="element-91" />
        <Verticals data-id="element-92" />
        <WhyPartner data-id="element-93" />
        <Contact data-id="element-94" />
      </main>
      <Footer data-id="element-95" />
    </div>;
}